import isEmpty from 'lodash/isEmpty';
import { FETCH_AUTHENTIC,
         SET_CURRENT_USER,
         SET_CURRENT_USER_PERFIL } from '../actions/authenticActions';

const INITIAL_STATE = { 
                        isAuthenticated  : false,
                        session          : null,
                        user             : {},
                        pontuacao        : {},
                        allUsuariosTurma : []
                      };


    export default function(state = INITIAL_STATE,action){

    switch (action.type) {

        case FETCH_AUTHENTIC:
    
            return {
                    isAuthenticated : !isEmpty(action.payload.data),
                    session         : action.payload.data.session[0],
                    pontuacao       : action.payload.data.session[0].pontuacao
                   }

        case SET_CURRENT_USER:
                        
            return{
                    isAuthenticated : !isEmpty(action.session),
                    user            : action.user,
                    session         : action.session,
                    pontuacao       : action.pontuacao
                  };

        case SET_CURRENT_USER_PERFIL:
                
            var sessao  = JSON.parse(localStorage.getItem("session"));
            sessao.foto = action.payload.data;
            localStorage.setItem('session',JSON.stringify(sessao));
           const foto =  state.session.foto = action.payload.data;
            return {...state,foto}
        
        default:
            return state;
    }

}


// WEBPACK FOOTER //
// ./src/reducers/reducer_login.js